<template>
  <base-tutorial :steps="steps">
    <div>
      <h2>
        Introdução
      </h2>
      <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
        Olá! Nos “Filtros de busca” você poderá realizar busca por dados cadastrados pelos servidores no
        módulo “Perfil”.
      </p>
      <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
        Inicialmente, você realiza a seleção da(s) unidade(s), utilizando os seguintes recursos:
        <ul>
          <li>
            <p class="text-start font-weight-medium text-lg-h6">
              Selecionar todos: seleciona todas as unidades disponíveis para sua pesquisa, incluindo as
              unidades hierarquicamente vinculadas a sua.
            </p>
          </li>
          <li>
            <p class="text-start font-weight-medium text-lg-h6">
              Expandir lista: apresenta todas as unidades disponíveis para sua pesquisa, incluindo as
              unidades hierarquicamente vinculadas a sua.
            </p>
          </li>
        </ul>
        A opção “Pesquisar” está disponível para facilitar a busca por unidade específica.
      </p>
      <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
        Ao lado das “Unidades”, estão disponíveis os recursos para expansão e seleção individual, bem
        como, a opção de selecionar todas as unidades hierarquicamente vinculadas.
      </p>
    </div>

    <div>
      <h2>
        Filtros de Busca
      </h2>
      <div>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Os filtros disponíveis para buscas estão apresentados de acordo com as seções do módulo Perfil:
          Cadastro, Formação, Atuação Profissional, Interesses Pessoais e Preferências de Trabalho.
        </p>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Após selecionar os filtros desejados para realizar a busca, clique no botão “pesquisar” localizado ao
          final da página. Em seguida, aparecerá o “Resumo dos filtros” que você utilizou para pesquisa e, na
          sequência, a tabela “Resultados” na qual você encontra a lista com os servidores que atendem aos
          filtros pesquisados.
        </p>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          A coluna “Perfil” permite acessar o perfil completo de cada servidor encontrado na busca.
        </p>
      </div>
    </div>

    <div>
      <h2>Importante!</h2>
      <div class="mx-2 pa-2 justify-center">
        <ul>
          <li>
            <p class="text-start font-weight-medium info--text text-lg-h6">
              A opção “Pesquisar Outro(s)” permite a pesquisa por termos inseridos pelo servidor na etapa Perfil
              e não disponibilizados na barra de busca. É possível, ainda, realizar a busca, na opção “Pesquisar
              Outro(s)”, utilizando apenas parte do termo inserido.
            </p>
          </li>
          <li>
            <p class="text-start font-weight-medium info--text text-lg-h6">
              Caso não deseje mais utilizar o filtro, basta desativá-lo no componente on/off ao lado de cada filtro.
            </p>
          </li>
          <li>
            <p class="text-start font-weight-medium info--text text-lg-h6">
              Você poderá imprimir o relatório com o resumo dos filtros e o resultado da busca realizada.
            </p>
          </li>
        </ul>
      </div>
    </div>
  </base-tutorial>
</template>

<script>
import BaseTutorial from '../../BaseTutorial';

export default {
  name: 'TutorialMonitoramentoPerfilFiltrosBusca',
  components: { BaseTutorial },
  data: () => ({
    steps: [
      'Introdução',
      'Filtros de Busca',
      'Importante',
    ],
  }),
};
</script>

<style></style>
